import {
  Grid,
  RACButton,
  RACModalCard,
  Typography,
} from '@rentacenter/racstrap';
import { ReactComponent as AlertIcon } from '../../Assets/no-records-found.svg';
import { EmilyGlobalStyles } from '../../Styles/emilystyles';
import React from 'react';
// import { useContext } from 'react';
// import { CreditCardContext } from './CreditcardContext';
import { useHistory } from 'react-router-dom';

export default function SomethingWentWrongPopUp(props: any) {
  const classes = EmilyGlobalStyles();
  const history = useHistory();
  //const { mngMsg } = useContext(CreditCardContext);
  return (
    <RACModalCard
      isOpen={props.tab}
      closeIcon={false}
      maxWidth="xs"
      borderRadius="25px !important"
    >
      <div
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.titlealign}>
          <AlertIcon></AlertIcon>
          <Typography className={`${classes.formLabel}  ${classes.mt2}`}>
            {props.msg}
          </Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.titlealign}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              history.goBack();
            }}
          >
            Ok
          </RACButton>
        </Grid>
      </div>
    </RACModalCard>
  );
}
